export default __webpack_public_path__ + "static/marekk-bab195591ea1fcd6f5ee28d661d0132a.png";